import { useState } from 'react';
import { Box } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { StartConfiguration, WizardConfiguration } from '../components';
import { INTERNAL_STEPPER } from '../constants';

export const AdminFirstConfiguration = () => {
  const [stepper, setStepper] = useState(INTERNAL_STEPPER.START);
  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box
      display='flex'
      flexDirection='column'
      maxWidth='1400px'
      mx='auto'
      px={genericResponsiveValue({
        breakPoints: { desktop: 'huge', tablet: 'huge' },
        defaultValue: 'none',
      })}
    >
      {stepper === INTERNAL_STEPPER.START && <StartConfiguration.Admin setStepper={setStepper} />}
      {stepper === INTERNAL_STEPPER.CONFIGURATION && <WizardConfiguration.Admin />}
    </Box>
  );
};
